// extracted by mini-css-extract-plugin
export default {"header":"kXGpy6","revShareBadge":"_f_TrS"};